import React, { useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { useQuery } from '@apollo/client';
import { withRouter } from 'react-router-dom';

import withProjectSidebar from '../../../components/with-project-sidebar';
import Tabs from '../../../constants/tabs';
import CardSortAnalytics from './card-sort';
import { GET_ANALYTICS_CARD_SORT } from './graphql';

import {
  Loader,
  Dropdown,
  Message,
} from './styles';
import withScroll from '../../../components/with-scroll';
import EmptyResult from '../components/empty-result';
import EmptyResultSegment from '../components/empty-segment';

const ProjectAnalyticsCardSort = (props) => {
  const [segmentSelected, setSegmentSelected] = useState('all');
  const [activeTab, setActiveTab] = useState(0);

  const {
    project,
  } = props;

  const {
    segments,
  } = project;

  const {
    loading,
    data: analyticsData = {},
    errors,
  } = useQuery(GET_ANALYTICS_CARD_SORT, {
    variables: {
      projectId: project.id,
      segmentId: segmentSelected !== 'all' ? segmentSelected : undefined,
    },
  });

  const { analytics = {} } = analyticsData;
  const { cardSort = {} } = analytics;

  const dropdownOptions = useMemo(() => [
    { key: 1, text: 'All audience segments', value: 'all' },
    ...segments.map((segment) => ({
      key: segment.id,
      text: segment.name,
      value: segment.id,
    })),
  ], [segments]);

  const handleChangeTab = (e, data) => {
    setActiveTab(data.activeIndex);
  };

  if (cardSort?.length === 0 && segmentSelected === 'all') {
    return (
      <EmptyResult testType="card_sort" />
    );
  }

  if (loading) {
    return <Loader data-loader="project-analytics-card-sort-loader" />;
  }

  if (errors) {
    return (
      <Message>
        Error while fetching analytics.
      </Message>
    );
  }

  return (
    <>
      {segments.length > 1 && (
        <Dropdown
          placeholder="Select one segment"
          fluid
          selection
          value={segmentSelected}
          onChange={(event, data) => setSegmentSelected(data.value)}
          options={dropdownOptions}
        />
      )}
      {
        (cardSort?.length === 0 && segmentSelected !== 'all') && (
          <EmptyResultSegment />
        )
      }
      {
        cardSort?.length > 0 && (
          <CardSortAnalytics
            project={project}
            analyticsCardSort={cardSort}
            segmentId={segmentSelected !== 'all' ? segmentSelected : undefined}
            onChangeTab={handleChangeTab}
            activeTab={activeTab}
          />
        )
      }
    </>
  );
};

ProjectAnalyticsCardSort.propTypes = {
  project: PropTypes.shape({
    id: PropTypes.string,
    status: PropTypes.string,
    segments: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
    })),
  }).isRequired,
};

export default compose(
  withScroll,
  withRouter,
  withProjectSidebar({ selectedTab: Tabs.PROJECT }),
)(ProjectAnalyticsCardSort);
